<template>
    <div id="device_Info">
        <HrrBreadcrumb PMname="设备指令与日志" CMname="设备信息管理" />
        <HrrMainLayout :nobbr="false">
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="站点名称：">
                        <el-select v-model="searchform.siteId" placeholder="请选择" filterable>
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="设备编号" value="deviceNickCode"></el-option>
                                <el-option label="设备描述" value="deviceName"></el-option>
                                <el-option label="媒体编号" value="lightBoxCode"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="绑定：" prop="public">
                        <el-select v-model="searchform.bindType" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="已绑定" value="已绑定"></el-option>
                            <el-option label="未绑定" value="未绑定"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态：" prop="public">
                        <el-select v-model="searchform.status" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未使用" :value="0"></el-option>
                            <el-option label="使用" :value="1"></el-option>
                            <el-option label="维修" :value="2"></el-option>
                            <el-option label="损坏" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="在线状态：" prop="public">
                        <el-select v-model="searchform.isOnline" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="在线" value="1"></el-option>
                            <el-option label="离线" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备类型：" prop="public">
                        <el-select v-model="searchform.deviceType" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="灯箱" value="1"></el-option>
                            <el-option label="电子媒体" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons" >
                <el-row>
                    <el-col :span="12">
                        <el-button-group>
                            <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('Add')">新增</el-button>
                            <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('Update')">编辑</el-button>
                            <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="isHadFun('Delete')">删除</el-button>
                            <el-button type="primary" icon="el-icon-finished" size="small" @click="sendCmdClick" v-if="isHadFun('Testing')">发送指令</el-button>
                            <el-button type="primary" icon="el-icon-edit" size="small" @click="autoCreateClick" v-if="isHadFun('AutoCreate')">生成设备</el-button>
                            <el-button type="primary" icon="fa fa-arrows-alt" size="small" @click="distributionClick" v-if="isHadFun('distributionDevice')">分配设备</el-button>
                            <el-button type="info" icon="fa fa-undo" size="small" @click="returnMForm()" v-if="isShowReturn">返 回</el-button>
                        </el-button-group>
                    </el-col>
                    <el-col :span="2">
                        &nbsp;
                    </el-col>
                    <el-col :span="10" class="el-col-tj">
                        未使用数：<span>{{UnusedNum}}</span> 
                        使用数：<span>{{UsedNum}}</span> 
                        维修数：<span>{{RepairNum}}</span> 
                        已分配数：<span>{{DistributionNum}}</span>
                    </el-col>
                </el-row>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" :cell-style="cellStyle" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading" @sort-change="sortchange" >
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column type="index" width="55" fixed="left" label="序号" :index="getindex">
                    </el-table-column>
                    <el-table-column type="expand" fixed="left" label="配置" width="50">
                        <template slot-scope="props">
                            <el-form label-position="left" size="mini">
                                <el-form-item v-for="c in props.row.configs" :label="c.attrType+'：'">
                                    <span>{{ c.attrValue }}</span>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column prop="siteName" label="所属站点" width="150" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceType" label="设备类型" width="120" fixed="left"  sortable="custom" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.deviceType==1">灯箱</span>
                            <span v-if="scope.row.deviceType==2">电子媒体</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="媒体编号" width="120" fixed="left"  sortable="custom" >
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="140" sortable="custom" >
                        <template slot-scope="scope">
                            <el-tooltip content="查看分配的用户" placement="right">
                                <span style="cursor:pointer;">{{scope.row.deviceNickCode}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="分配" width="60" >
                        <template slot-scope="scope">
                                {{scope.row.bindUserNum>0?'已':'未'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="140" fixed="left" sortable="custom" v-if="isHadFun('deviceCode')">
                    </el-table-column>
                    <!--<el-table-column prop="deviceName" label="设备名称" width="160">
                    </el-table-column>-->
                    <el-table-column label="最后调试状态" width="120" v-if="isHadFun('debug')">
                        <template slot-scope="scope">
                            <el-tooltip :disabled="scope.row.lastDebugStatus!='err'" :content="scope.row.errinfo" placement="right">
                                <span style="cursor:help;">{{scope.row.lastDebugStatus}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastDeviceTime" label="最后设备时间" width="160" v-if="isHadFun('debug')">
                    </el-table-column>
                    <el-table-column label="调光信号类型" width="140" v-if="isHadFun('debug')">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastLightType==0">DC(0-10V)权限</span>
                            <span v-if="scope.row.lastLightType==1">PWM</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="abnormalInfo" label="异常信息" width="120" v-if="isHadFun('debug')">
                    </el-table-column>
                    <el-table-column prop="debug1Info" label="CCID" width="120" v-if="isHadFun('debug')">
                    </el-table-column>
                    <el-table-column prop="debug2Info" label="CSQ" width="120" v-if="isHadFun('debug')">
                    </el-table-column>
                    <el-table-column prop="lastWorkedTimeFormat" label="工作时长" width="140" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lastLight" label="亮度(%)" width="100" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lastPowerWaste" label="电流A-B-C(安)" width="140" sortable="custom">
                    </el-table-column>
                    <el-table-column label="AC通断电状态" width="140" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastACStatus==0">关断</span>
                            <span v-if="scope.row.lastACStatus==1">导通</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceVersion" label="当前版本号" width="140" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lastUpdateDate" label="最后更新时间" width="160" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="adId" label="广告ID" width="120">
                    </el-table-column>
                    <el-table-column prop="adTitle" label="广告名称" width="120">
                    </el-table-column>
                    <el-table-column label="广告更换是否正确" width="140">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isRight==0">错误</span>
                            <span v-if="scope.row.isRight==1">正确</span>
                            <span v-if="scope.row.isRight==2||typeof(scope.row.isRight)=='object'">未校验</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="160" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="80">
                    </el-table-column>
                    <!--<el-table-column prop="orderNumNoSend" label="指令未发送数"  width="110" fixed="right">
                    </el-table-column>
                    <el-table-column prop="orderNumComplete" label="指令已完成数" width="70" fixed="right">
                    </el-table-column>
                    <el-table-column prop="realDataNum" label="上传解码数" width="100" fixed="right">
                    </el-table-column>-->
                    <el-table-column label="绑定" width="80">
                        <template slot-scope="scope">
                            <span v-if="scope.row.bindtype=='已绑定'" style="color:#ccffff;">
                                <el-tooltip content="点击解绑" placement="right">
                                    <span style="cursor:pointer;">已绑定</span>
                                </el-tooltip>
                            </span>
                            <span v-if="scope.row.bindtype=='未绑定'" style="color:#666666;">
                                <!-- <span  >未绑定</span> -->
                                <el-tooltip content="点击绑定设备" placement="right">
                                    <span style="cursor:pointer;">未绑定</span>
                                </el-tooltip>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="设备状态" width="78" fixed="right">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" :disabled="scope.row.isOnline!=0" :content="'最后在线时间：'+scope.row.onlineTime" placement="top-start">
                                <i :class="'fa fa-2x '+linestatus(scope.row)" style="margin-left:12px;margin-top:4px;"></i>
                                <!--<i class="fa fa-wifi fa-2x device-online" style="margin-left:12px;margin-top:4px;"></i>-->
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="80" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-tag effect="dark" type="info" disable-transitions v-if="scope.row.status==0">未使用</el-tag>
                            <el-tag effect="dark" type="success" disable-transitions v-if="scope.row.status==1">使用</el-tag>
                            <el-tag effect="dark" type="warning" disable-transitions v-if="scope.row.status==2">维修</el-tag>
                            <el-tag effect="dark" type="danger" disable-transitions v-if="scope.row.status==3">损坏</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" header-align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small" v-if="isHadFun('Update')">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="isHadFun('Delete')">删除</el-button>
                            <el-badge :value="scope.row.orderTmepNum" type="warning" :hidden="scope.row.orderTmepNum==0" is-dot>
                                <el-button @click.stop="RowSendcmd(scope.row)" type="text" size="small" v-if="isHadFun('Testing')">发送指令</el-button>
                            </el-badge>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchform.pageNum" :page-sizes="[5, 10, 15,30]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
        <!--弹窗-->
        <el-dialog :title="(this.isbatch?'批量':'单')+'指令'" v-model="dialogVisible" :visible.sync="dialogVisible" class="el-dialog-resume">
            <el-tabs v-model="tab" type="card" @tab-click="handleClick">
                <el-tab-pane label="定时指令" name="lightcmd">
                    <el-card class="educard" prop="prop">
                        <template slot-scope="scope">
                            <el-form class="eduform" label-width="80px" id="lightForm" prop="deviceType">
                                <el-form-item :label="'指令'+(index+1)+'：'" prop="time" v-for="(lorder,index) in lightform.list">
                                    运行时间：<el-select v-model="lorder.time" placeholder="小时" size="mini">
                                        <el-option v-for="item in timeData" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    ：<el-select v-model="lorder.min" placeholder="分钟" size="mini">
                                        <el-option v-for="item in minData" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>

                                    <span>{{deviceType==2?" 开关：":" 亮度(%)："}}</span>
                                    <el-input-number v-show="deviceType==1" v-model="lorder.percentage" :min="0" :max="100" label="亮度百分比" size="mini">
                                    </el-input-number >
                                    <el-radio-group v-show="deviceType==2" v-model="lorder.percentage">
                                        <el-radio :label="100" >开启</el-radio>
                                        <el-radio :label="0" >关闭</el-radio>
                                    </el-radio-group>

                                    &nbsp;<el-button type="info" @click="delLightOrder(lorder)" size="mini" v-if="index!=0">删除指令</el-button>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button type="danger" @click="AddLightOrder()" :disabled="disabled">添加指令</el-button>
                                    <el-button type="primary" @click="addCmd('light')">发送定时指令</el-button>
                                    <el-button type="info" @click="addCmd('close')" round>急停</el-button>
                                    <el-button type="danger" @click="addCmd('open')" round>解除急停</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="启动指令" name="startcmd">
                    <el-card class="educard" prop="prop">
                        <template slot-scope="scope">
                            <el-form class="eduform" label-width="180px" :model="startform" ref="startform">
                                <!-- <el-form-item label="错差间隔/分钟：" prop="min">
                             <el-time-select
                                placeholder="错差间隔"
                                v-model="startform.min"
                                :picker-options="{
                                  start: '00:00',
                                  step: '00:01',
                                  end: '00:59'
                                }">
                              </el-time-select>
                        </el-form-item> -->
                                <el-form-item label="每半小时指令获取次数：" prop="number">
                                    <el-select v-model="startform.number" placeholder="启动次数">
                                        <el-option v-for="item in numberData" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button type="primary" @click="addCmd('start')">发送启动指令</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="数据上传周期指令" name="uploadcyclecmd">
                    <el-card class="educard" prop="prop">
                        <template slot-scope="scope">
                            <el-form class="eduform" label-width="180px" :model="uploadcycleform" ref="uploadcycleform">
                                <el-form-item label="每半小时数据上传次数：" prop="cmd">
                                    <el-select v-model="uploadcycleform.min" placeholder="次数">
                                        <el-option v-for="item in uploadData" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button type="primary" @click="addCmd('uploadcycle')">发送数据上传周期指令</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-card>
                </el-tab-pane>
                <el-tab-pane label="自定义指令" name="mycmd">
                    <el-card class="educard" prop="prop">
                        <template slot-scope="scope">
                            <el-form class="eduform" label-width="130px" :model="myform" ref="myform">
                                <el-form-item label="自定义指令：" prop="cmd">
                                    <el-input v-model="myform.cmd" type="textarea" :rows="4"></el-input>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button type="primary" @click="addCmd('my')">发送指令</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-card>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <el-dialog title="生成设备" v-model="autoCreateVisible" :visible.sync="autoCreateVisible" :before-close="handleClose" class="el-dialog-resume">
            <el-tabs type="card">
                <el-card class="educard">
                    <template>
                        <el-form class="eduform" label-width="130px" :model="searchform" ref="searchform">
                            <el-form-item label="生成个数：">
                                <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="generateNumber" placeholder="请输入个数" style="width: 300px"></el-input>
                            </el-form-item>
                            <el-form-item label=" ">
                                <el-button type="primary" @click="determineGenerate()">确定</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-card>
            </el-tabs>
        </el-dialog>
        <el-dialog title="分配设备归属" v-model="distributionVisible" :visible.sync="distributionVisible" class="el-dialog-resume edrs">
            <el-form label-width="130px" :model="distributionform" ref="distributionform">
                <el-form-item label="已选设备：">
                    <el-tag :key="tag.id" v-for="tag in selectionRows" closable :disable-transitions="false" @close="handleTagClose(tag)" style="margin-right:10px;">
                        <span>{{tag.deviceNickCode}}</span></span>
                    </el-tag>
                </el-form-item>
                <el-form-item label="选择用户：">
                    <el-select v-model="selectionUser" placeholder="请选择" filterable multiple width="400px">
                        <el-option v-for="item in useridData" :key="item.UserId" :label="item.UserName+'('+item.UserAccount+')'" :value="item.UserId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="distributionDevices()">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="设备分配用户" v-model="deviceUserVisible" :visible.sync="deviceUserVisible" class="el-dialog-resume">
            <el-table :data="DeviceUserData" ref="deviceUserTable" border stripe style="width: 100%" v-loading="DUloading">
                <el-table-column type="index" label="序号" width="50" fixed="left">
                </el-table-column>
                <el-table-column prop="deviceNickCode" label="设备编号" width="140">
                </el-table-column>
                <el-table-column prop="userName" label="用户名" width="120">
                </el-table-column>
                <el-table-column prop="userAccount" label="账户名" width="160">
                </el-table-column>
                <el-table-column prop="userMobile" label="手机号" width="160">
                </el-table-column>
                <el-table-column prop="userEmail" label="Email" width="200">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click.stop="unBindUser(scope.row)" type="text" size="small">解绑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="绑定设备" v-model="bindVisible" :visible.sync="bindVisible" class="el-dialog-resume edrs">
            <el-form label-width="130px" :model="bindform" ref="bindform">
                <el-form-item label="设备编号：" prop="deviceNickCode">
                        <span >
                            {{deviceNickCode}}
                        </span>
                    </el-form-item>
                <el-form-item label="站点：" prop="bindSiteId">
                    <el-select v-model="bindSiteId" @change="changeSiteId" placeholder="请选择" filterable>
                        <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="媒体编号：" prop="bindLightBoxId">
                    <el-select v-model="bindLightBoxId" placeholder="请选择" filterable>
                        <el-option v-for="item in lightBoxCodeData" :key="item.lightBoxId" :label="item.lightBoxCode" :value="item.lightBoxId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="bindLightBox()">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'device_info',
    data() {
        return {
            tab: "lightcmd",
            disabled: false,
            searchform: {
                pageNum: 1,
                pageSize: 10,
                siteId: "",
                deviceName: "",
                deviceNickCode: "",
                deviceCode:"",
                lightBoxCode: "",
                status: "",
                bindType: "",
                isOnline: "",
                ColumnName: "",
                OrderType: "",
                deviceType:""
            },
            myform: {
                cmd: ""
            },
            lightform: {
                list: [{
                    time: "00",
                    min: "00",
                    percentage: 0
                }]
            },
            startform: {
                // min:"",
                number: "01"
            },
            cmdform: {
                MN: "",
                Content: ""
            },
            uploadcycleform: {
                min: "01",
                cmd: ""
            },
            distributionform: {
                deviceId: "",
                userId: ""
            },

            tableData: [],
            planIdData: [],
            timeData: [],
            minData: [],
            numberData: [],
            siteidData: [],
            lightBoxCodeData: [],
            useridData: [],
            DeviceUserData: [],
            uploadData: [],
            total: 0,
            loading: true,
            DUloading: true,
            selectionRows: [],
            selectionUser: [],
            selectfield: "deviceNickCode",
            keyword: "",
            dialogVisible: false,
            autoCreateVisible: false,
            distributionVisible: false,
            deviceUserVisible: false,
            generateNumber: "",
            isbatch: false,
            isFormLightbox: true,
            DURow: {},
            isShowReturn:false,
            returnPath:"",
            UnusedNum:0,
            UsedNum:0,
            RepairNum:0,
            DistributionNum:0,
            bindSiteId: "",
            bindLightBoxId:"",
            bindVisible:false,
            bindform:{
                deviceId:"",
                lightBoxId:"",
            },
            deviceNickCode:"",
            deviceArray:['AD0000000146','AD0000000179','AD0000000202','AD0000000210','AD0000000218','AD0000000224','AD0000000225','AD0000000226','AD0000000227','AD0000000228'],
            deviceType:"2",//设备类型属性，如果1为灯箱，2为媒体，用于控制命令窗口中的控件显示
        }
    },
    methods: {
        getindex(index){
            return this.searchform.pageSize*(this.searchform.pageNum-1)+index+1;
        },
        changeSiteId(val) {
            this.bindSiteId = val;
            this.bindform.lightBoxId="",
            this.bindLightBoxId="";
            this.lightBoxData();
        },
        lightBoxData(){
            var Vuethis = this;
            this.$hrraxios.get(this.$api.device.getNoDevice + "/" + this.bindSiteId)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.lightBoxCodeData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        onSubmit() {
            this.searchform.deviceNickCode = "";
            this.searchform.deviceName = "";
            this.searchform.lightBoxCode = "";
            this.searchform[this.selectfield] = this.keyword.trim();
            this.searchform.pageNum = 1;
            this.$route.meta.searchform = this.searchform;
            this.initData();
        },
        linestatus(row) {
            if(this.deviceArray.indexOf(row.deviceCode)>-1){
                return  "fa-wifi device-online";
            }

            // if(row.deviceCode=='AD0000000228' || row.deviceCode=='AD0000000218'){
            //     return  "fa-wifi device-online";
            // }
            if (row.lastDebugStatus == "err") {
                return "fa-exclamation-circle device-error";
            }
            if (row.isOnline == null) {
                return "fa-wifi device-never";
            }
            if (row.isOnline == 1) {
                return "fa-wifi device-online";
            }
            if (row.isOnline == 0) {
                return "fa-wifi device-offline";
            }
        },
        formatError(v){
            var errOneArr=["没导通，即实际值比真实值大10%","信号异常","AC检测异常","AC通电异常","AC断电异常"];
            var returnInfo="";
            var startindex=0;
            var TenForTwo=function(num){
                return num>1?(TenForTwo(parseInt(num/2))+(num%2).toString()):"1";
            };
            var twoinfo=TenForTwo(v);
            var errorinfo="00000000".substring(0,(8-twoinfo.length))+twoinfo;
            for(var i=errorinfo.length-1;i>0;i--){
                var bit=errorinfo.substring(i,i+1);
                if(bit=='1'){
                    returnInfo+="【"+errOneArr[startindex]+"】";
                }
                startindex++;
            }
            //console.log(errorinfo);
            console.log(returnInfo);
            return returnInfo;
        },
        sortchange(sortinfo) {
            this.searchform.ColumnName = sortinfo.order == null ? null : (sortinfo.prop == "lastWorkedTimeFormat" ? "lastWorkedTime" : sortinfo.prop);
            this.searchform.OrderType = sortinfo.order;
            this.initData();
        },
        handleTagClose(tag) {
            if (this.selectionRows.length > 1) {
                this.selectionRows.splice(this.selectionRows.indexOf(tag), 1);
                this.$refs.Opentable.toggleRowSelection(tag);
            } else {
                this.$message({ message: "至少要选择一个设备", type: "warning" });
            }
        },
        expandchange(row, expandedRows) {
            if (expandedRows.length > 0) {
                var Vuethis = this;
                var conRow = row;
                this.$hrraxios.get(this.$api.device.config + "/" + row.deviceId)
                    .then(function(response) {
                        var data = response.data;
                        if (data.Success == true) {
                            conRow.configs = data.Data;
                        } else {
                            Vuethis.$message.error(data.Prompt);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.$route.meta.searchform = this.searchform;
            this.initData();
        },
        Rowview(val) {
            this.$route.meta.row = val;
            this.$route.meta.parentReturnPath = this.returnPath;
            this.$router.push({ path: '/device/info/view/' + this.isFormLightbox + "/" + val.deviceId });
        },
        RowEdit(val) {
            this.$route.meta.row = val;
            this.$route.meta.parentReturnPath = this.returnPath;
            var LBID=this.$route.params.lightboxid?"/"+this.$route.params.lightboxid:"";
            this.$router.push({ path: '/device/info/edit/' + this.isFormLightbox + "/" + val.deviceId +LBID });
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.deviceNickCode + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.device.delDevice + "/" + val.deviceId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });

        },
        RowSendcmd(val) {
            this.dialogVisible = true;
            this.isbatch = false;
            this.cmdform.MN = val.deviceCode;
            this.deviceType=val.deviceType;
        },
        RowFlow(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/device/flowreport/' + val.deviceNickCode });
        },
        distributionClick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
            this.initUserIdData();
            this.distributionVisible = true;
        },
        badgeClick(val) {
            this.$router.push({ path: '/device/orderTemp/' + this.val })
        },
        Addclick() {
            this.$router.push({ path: '/device/info/add/' + this.isFormLightbox });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        pubclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
        },
        editclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
            if (this.selectionRows.length > 1) {
                this.$message({ message: "只能操作一行数据", type: "warning" });
                return;
            }
            this.$route.meta.row = this.selectionRows[0];
            var LBID=this.$route.params.lightboxid?"/"+this.$route.params.lightboxid:"";
            this.$router.push({ path: '/device/info/edit/' + this.isFormLightbox + "/" + this.selectionRows[0].deviceId +LBID});
        },
        sendCmdClick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在发送", type: "warning" });
                return;
            }
            this.isbatch = true;
            this.dialogVisible = true;
            this.deviceType=this.selectionRows[0].deviceType;
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios({
                            method: "delete",
                            url: this.$api.device.delDevice + "/" + myrow.deviceId
                        })
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        returnMForm() {
            this.$router.push({ path: this.returnPath });
        },
        distributionDevices() {
            if (this.selectionUser.length == 0) {
                this.$message({ message: "请选择用户在提交！", type: "warning" });
                return;
            }
            var loading = this.$loading({
                lock: true,
                text: '分配中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var Vuethis = this;
            var PostfunArr = [];
            this.selectionRows.forEach(myrow => {
                this.selectionUser.forEach(uid => {
                    var postRe = this.$hrraxios({
                        method: "post",
                        url: this.$api.device.binduser,
                        data: {
                            deviceid: myrow.deviceId,
                            userid: uid
                        }
                    })
                    PostfunArr.push(postRe);
                });
            });
            this.$axios.all(PostfunArr)
                .then(this.$axios.spread(function() {
                    loading.close();
                    //console.log(arguments);
                    var isalldel = true;
                    for (var i = 0; i < arguments.length; i++) {
                        if (arguments[i].data.Success == false) {
                            isalldel = false;
                        }
                    }
                    if (isalldel == true) {
                        Vuethis.$message({ message: "全部分配成功！", type: "success" });
                        Vuethis.distributionVisible = false;
                        Vuethis.$refs.Opentable.clearSelection();
                        Vuethis.initData();
                    } else {
                        //有删除失败的未处理
                    }
                }));
        },
        autoCreateClick() {
            this.autoCreateVisible = true;
        },
        determineGenerate() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.device.autoCreate + "/" + this.generateNumber)
                .then((response) => {
                    var redata = response.data;
                    if (redata.Success == true) {
                        Vuethis.$message({ message: "设备生成成功！", type: "success" });
                        Vuethis.generateNumber = ""
                        Vuethis.autoCreateVisible = false;
                        Vuethis.initData();
                    } else {
                        Vuethis.$message({ message: redata.Prompt, type: "error" });
                    }
                })
        },
        handleClose(done) {
            this.generateNumber = "";
            done();
        },
        cellclick(row, column, cell, event) {
            //console.log(row);
            if (column.label == "指令未发送数") {
                this.$common.getSeeFunListByMCode(this, "DeviceOrder", (callback) => {
                    if (callback.length != 0) {
                        this.$router.push({ path: '/device/orderdata/' + row.deviceNickCode + '/0' });
                    } else {
                        this.$message({ message: "抱歉，您没有查看指令权限", type: "warning" });
                    }
                });
            }
            if (column.label == "指令已完成数") {
                this.$common.getSeeFunListByMCode(this, "DeviceOrder", (callback) => {
                    if (callback.length != 0) {
                        this.$router.push({ path: '/device/orderdata/' + row.deviceNickCode + '/2' });
                    } else {
                        this.$message({ message: "抱歉，您没有查看指令权限", type: "warning" });
                    }
                });
            }
            if (column.label == "上传解码数") {
                this.$common.getSeeFunListByMCode(this, "DeviceRealData", (callback) => {
                    if (callback.length != 0) {
                        this.$router.push({ path: '/device/getrealdata/' + row.deviceNickCode });
                    } else {
                        this.$message({ message: "抱歉，您没有查看上传解码权限", type: "warning" });
                    }
                });
            }
            if (column.label == "设备编号") {
                this.deviceUserVisible = true;
                this.initDeviceUserData(row);
            }
            if (column.label == "绑定") {
                if (row.bindtype == "已绑定") {
                    this.$confirm("你确定要解绑【" + row.deviceNickCode + "】设备与媒体的关系么？ 请慎重操作！！", { type: "warning" })
                        .then(() => {
                            var Vuethis = this;
                            this.$hrraxios({
                                    method: "get",
                                    url: this.$api.device.unbindLightBox + "/" + row.deviceId,
                                })
                                .then((response) => {
                                    var redata = response.data;
                                    if (redata.Success == true) {
                                       // Vuethis.$message({ message: "解绑成功！", type: "success" });
                                        Vuethis.unbindUsers(row.deviceId);
                                       // Vuethis.initData();
                                    } else {
                                        Vuethis.$message({ message: redata.Prompt, type: "error" });
                                    }
                                });
                                
                        });
                }
                if (row.bindtype == "未绑定") {
                    this.bindVisible=true;
                    this.deviceNickCode=row.deviceNickCode;
                    this.bindform.deviceId=row.deviceId;
                    console.log("未绑定");
                }
            }
            this.$refs.Opentable.toggleRowSelection(row);
        },
        //解除所有用户
        unbindUsers(deviceId){
            var Vuethis=this;
            this.$hrraxios({
                method: "delete",
                url: this.$api.device.unbindusers  + "/" + deviceId
               //  data: deviceId
            })
            .then((response) => {
                var dedata = response.data;
                if (dedata.Success == true) {
                    Vuethis.$message({ message: "解绑成功！", type: "success" });
                    Vuethis.initData();
                } else {
                    Vuethis.$message({ message: dedata.Prompt, type: "error" });
                }
            });
        },
        //绑定灯箱
        bindLightBox(){
            if (this.bindLightBoxId  =="") {
                this.$message({ message: "请选择媒体在提交！", type: "warning" });
                return;
            }
            var loading = this.$loading({
                lock: true,
                text: '绑定中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var Vuethis = this;
            this.bindform.lightBoxId=this.bindLightBoxId;
            this.$hrraxios.get(this.$api.device.updatelightboxdevice, { params:this.bindform })
            .then(function(response){
                loading.close();
                var dedata = response.data;
                if (dedata.Success == true) {
                    
                    Vuethis.$message({ message: "绑定成功！", type: "success" });
                    Vuethis.bindVisible=false;
                    Vuethis.initData();
                } else {
                    Vuethis.$message({ message: dedata.Prompt, type: "error" });
                }
            });
        },
        cellStyle(row, column, rowIndex, columnIndex) {
            if (row.column.label === "指令未发送数" || row.column.label === "指令已完成数" || row.column.label === "上传解码数") {
                return 'font-weight: bolder;cursor:pointer;color:#ff9c70;text-align:center'
            }
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initDeviceUserData(row) {
            var Vuethis = this;
            this.DUloading = true;
            this.DURow = row;
            this.$hrraxios.get(this.$api.device.GetDeviceUserList + row.deviceCode)
                .then(function(response) {
                    Vuethis.DUloading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.DeviceUserData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.DUloading = false;
                    console.log(error);
                });
        },
        analysisLight(cmd) {
            let cmdArr = cmd.split(",");
            let re = "";
            for (let i = 0; i < cmdArr.length; i++) {
                let hour = cmdArr[i].substring(2, 4);
                let min = cmdArr[i].substring(4, 6);
                let l = cmdArr[i].substring(6, 9);
                re += "[亮度在" + hour + "时" + min + "分" + "亮度调整为" + parseInt(l) + "%]";
            }
            return re;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(this.$api.device.getdeviceList, { params: this.searchform })
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.UnusedNum=data.Data.UnusedNum;
                        Vuethis.UsedNum=data.Data.UsedNum;
                        Vuethis.RepairNum=data.Data.RepairNum;
                        Vuethis.DistributionNum=data.Data.DistributionNum;
                        Vuethis.tableData.forEach(item => {
                            if (item.lastWorkedTime != null && item.lastWorkedTime != "") {
                                let WkArr = item.lastWorkedTime.toString().split(".");
                                let min = parseInt((item.lastWorkedTime - WkArr[0]) * 60);
                                item.lastWorkedTimeFormat = WkArr[0] + "小时" + min + "分";
                            } else {
                                item.lastWorkedTimeFormat = null;
                            }
                            item.errinfo="";
                            if(item.lastDebugStatus=='err'){
                                item.errinfo=Vuethis.formatError(item.abnormalInfo);
                            }
                            Vuethis.$hrraxios.get(Vuethis.$api.device.config + "/" + item.deviceCode)
                                .then(function(response) {
                                    var data = response.data;
                                    if (data.Success == true) {
                                        item.configs = data.Data;
                                        item.configs.forEach((item, index) => {
                                            if (item.attrType == "light") {
                                                item.attrType = "调光";
                                                item.attrValue = Vuethis.analysisLight(item.attrValue);
                                            }
                                            if (item.attrType == "start") {
                                                item.attrType = "启动周期";
                                                item.attrValue = "每半小时指令获取" + item.attrValue.substring(2, 4) + "次";
                                            }
                                            if (item.attrType == "update") {
                                                item.attrType = "更新";
                                                let uarr = item.attrValue.split(";");
                                                item.attrValue = uarr[4] + ";" + uarr[5];
                                            }
                                            if (item.attrType == "urgentstop") {
                                                item.attrType = "急停";
                                                item.attrValue = item.attrValue == "031" ? "解除急停" : "急停";
                                            }
                                            if (item.attrType == "uploadcycle") {
                                                item.attrType = "数据上传周期";
                                                item.attrValue = "每半小时数据上传" + item.attrValue.substring(2, 4) + "次";
                                            }
                                            if (item.attrType == "custom") {
                                                item.attrType = "自定义指令";
                                            }
                                            if (item.attrType == "open") {
                                                item.attrType = "开灯";
                                                item.attrValue += "(弃用)";
                                            }
                                            if (item.attrType == "close") {
                                                item.attrType = "关灯";
                                                item.attrValue += "(弃用)";
                                            }
                                            item.attrValue += "(最后操作时间：" + (item.lastUpdateDate == null ? item.creationDate : item.lastUpdateDate) + ")";
                                        });
                                    } else {
                                        Vuethis.$message.error(data.Prompt);
                                    }
                                })
                        });
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initUserIdData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.system.userall)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.useridData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        initTime() {
            for (let i = 0; i <= 23; i++) {
                this.timeData.push((i.toString().length == 1) ? "0" + i.toString() : i.toString());
            }
            for (let i = 0; i <= 59; i++) {
                this.minData.push((i.toString().length == 1) ? "0" + i.toString() : i.toString());
            }
            for (let i = 1; i <= 60; i++) {
                this.numberData.push((i.toString().length == 1) ? "0" + i.toString() : i.toString());
            }
            for (let i = 1; i <= 60; i++) {
                this.uploadData.push((i.toString().length == 1) ? "0" + i.toString() : i.toString());
            }
        },
        AddLightOrder() {
            if (this.lightform.list.length < 9) {
                this.lightform.list.push({ time: "00", min: "00", percentage: 0 });
            } else {
                this.$message({ message: "最多添加9条灯光指令", type: "warning" });
                this.disabled = true
            }

        },
        delLightOrder(item) {
            var index = this.lightform.list.indexOf(item)
            if (index !== -1) {
                this.disabled = false
                this.lightform.list.splice(index, 1);
            }
        },
        initParamsData() {
            //this.$common.getplanlist(this,"planIdData");
            //this.$common.getFunListByMCode(this,"PlanOpen");
            var Vuethis = this;
            this.$hrraxios.get(this.$api.site.downlist)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.siteidData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        addCmd(type) {
            var orderMessage = "";
            switch (type) {
                case "my":
                    orderMessage = "自定义";
                    break;
                case "light":
                    orderMessage = "调光";
                    break;
                case "start":
                    orderMessage = "启动";
                    break;
                case "open":
                    orderMessage = "开灯";
                    break;
                case "close":
                    orderMessage = "关灯";
                    break;
                case "uploadcycle":
                    orderMessage = "数据上传周期";
                    break;
            }
            this.$confirm("你确定要发送 【" + orderMessage + "】 指令么？", { type: "warning" })
                .then(() => {
                    this.cmdform.Content = "";
                    if (type == "my") {
                        this.cmdform.Content = this.myform.cmd;
                    }
                    if (type == "light") {
                        let LorderList = this.lightform.list;
                        for (let i = 0; i < LorderList.length; i++) {
                            let p = LorderList[i].percentage.toString();
                            p = (p.length == 1) ? "00" + p : p;
                            p = (p.length == 2) ? "0" + p : p;
                            this.cmdform.Content += "00" + LorderList[i].time + LorderList[i].min + p + (i < (LorderList.length - 1) ? "," : "");
                        }
                    }
                    if (type == "start") {
                        // this.cmdform.Content="01"+this.startform.min.split(":")[1]+this.startform.number;
                        this.cmdform.Content = "01" + this.startform.number + "00";
                    }
                    if (type == "open") {
                        this.cmdform.Content = "031"
                    }
                    if (type == "close") {
                        this.cmdform.Content = "030"
                    }
                    if (type == "uploadcycle") {

                        this.cmdform.Content = "04" + this.uploadcycleform.min + "00";
                    }
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.$api.OrderTemp.api;
                    if (this.isbatch) {
                        var PostfunArr = [];
                        this.selectionRows.forEach(myrow => {
                            var postRe = this.$hrraxios.post(apiUrl, { MN: myrow.deviceCode, Content: this.cmdform.Content })
                            PostfunArr.push(postRe);
                        });
                        this.$axios.all(PostfunArr)
                            .then(this.$axios.spread(function() {
                                loading.close();
                                //console.log(arguments);
                                var isalldel = true;
                                for (var i = 0; i < arguments.length; i++) {
                                    if (arguments[i].data.Success == false) {
                                        isalldel = false;
                                    }
                                }
                                if (isalldel == true) {
                                    Vuethis.$message({ message: "全部发送成功！", type: "success" });
                                    Vuethis.dialogVisible = false;
                                    Vuethis.initData();
                                } else {
                                    //有删除失败的未处理
                                }
                            }));
                    } else {
                        this.$hrraxios.post(apiUrl, this.cmdform)
                            .then(function(response) {
                                loading.close();
                                var data = response.data;
                                if (data.Success == true) {
                                    Vuethis.$alert("指令提交成功！", {
                                        callback: action => {
                                            Vuethis.dialogVisible = false;
                                            Vuethis.initData();
                                        }
                                    });
                                } else {
                                    Vuethis.$message({ message: data.Prompt, type: "error" });
                                }
                            }).catch(function(error) {
                                loading.close();
                                console.log(error);
                            })
                    }
                });
        },
        unBindUser(row) {
            this.$confirm("确定要解绑此用户么？", "解绑提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    var form = {};
                    form.deviceid = row.deviceId;
                    form.userid = row.userId;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.device.unbinduser,
                            data: form
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "解绑成功！", type: "success" });
                                Vuethis.initDeviceUserData(Vuethis.DURow);
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        to.meta.parentReturnPath = from.meta.parentReturnPath;
        next();
    },
    beforeRouteEnter(to, from, next) {
        if (from.path.indexOf("device/info") == -1 && from.path.indexOf("lightbox/info") == -1) {
            delete to.meta.searchform;
            delete from.meta.searchform;
        }
        next(vm=>{
            if (from.path.indexOf("device/info") == 1 && from.path.indexOf("lightbox/info") == -1) {
                vm.returnPath = from.meta.parentReturnPath;
            } else {
                vm.returnPath = from.path;
            }
        });
    },
    created() {
        this.isShowReturn=(this.$route.params.dcode||this.$route.params.id||this.$route.params.lightboxid)?true:false;
        if (this.$route.params.id) {
            this.searchform.siteId = parseInt(this.$route.params.id);
        }
        if(this.$route.params.dcode){
            this.searchform.deviceCode=this.$route.params.dcode;
        }
        if(this.$route.params.lightboxid){
            this.searchform.bindType="未绑定";
        }
        if (this.$route.meta.searchform != undefined) {
            this.searchform = this.$route.meta.searchform;
            this.$common.FindhadValue(["deviceName","deviceNickCode","lightBoxCode"],this.searchform,this);
        }
        this.$common.getFunListByMCode(this, "DeviceInfo", () => {
            this.initTime();
            this.initData();
            this.initParamsData();
        });

    }
};
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}

#lightForm .el-select {
    width: 100px;
}

#deviceinfo .el-table .cell {
    overflow: visible;
}

#deviceinfo .el-badge__content.is-fixed {
    top: 8px;
    right: 8px;
}

#deviceinfo span.el-tooltip:hover {
    font-weight: bold;
}

.edrs .el-select {
    width: 300px;
}
#deviceinfo .el-badge{
    margin-left: 8px;
}
.el-col-tj{
    line-height: 32px;
    height: 32px;
    text-align:right;
    color: #7bb9f9;
    font-size: 14px;
}
.el-col-tj span{
    font-weight: bold;
    margin:0 4px;
    color: #fff;
    font-size: 18px;
}
</style>